// One total line under the Client page's Pricing History grid. There is one per currency, so amounts in different
// currencies are never added together.
export default class ClientPricingHistoryTotalItem {
  constructor(item) {
    if (item === undefined) {
      this.Currency = '';
      this.InvoicedEvaluations = '';
      this.ClientFee = '';
      this.FeePerEvaluation = '';
      return;
    }
    this.Currency = item.currency ?? '';
    this.InvoicedEvaluations = item.invoicedEvaluations;
    this.ClientFee = item.clientFee;
    this.FeePerEvaluation = item.feePerEvaluation;
  }

  static NameOfTheIdField() {
    return 'Currency';
  }

  static nameOfTheItemDetailList() {
    return 'Pricing History Total';
  }

  static MoneyFields = ['ClientFee', 'FeePerEvaluation'];
  static Currency() {
    return 'Currency';
  }
  static MoneyFieldsSecondary = [];
  static CurrencySecondary() {
    return '';
  }

  static DateFields = [];
  static BoolFields = [];

  static FieldsToShowInListTable = [];

  static FieldsToShowInDataTable() {
    return [
      { label: 'Currency', orderById: '', data: 'Currency' },
      { label: 'Invoiced Evaluations', orderById: '', data: 'InvoicedEvaluations', className: 'text-right' },
      { label: 'Client Fee', orderById: '', data: 'ClientFee', className: 'text-right' },
      { label: 'Fee per Evaluation', orderById: '', data: 'FeePerEvaluation', className: 'text-right' },
    ];
  }
}
